module.exports = __webpack_public_path__ + "static/img/1.f6aedad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/eng/1.png
// module id = 2qgH
// module chunks = 0